function getDoubleMatch(sourceCard, hand) {
  let cardToPlay = ''
  let cards = ''

  if (hasValidRows(hand)) {
    cardToPlay = checkForMatch(sourceCard, hand.slice(0, 3))
    if (cardToPlay) {
      return cardToPlay
    }

    cardToPlay = checkForMatch(sourceCard, hand.slice(3, 6))
    if (cardToPlay) {
      return cardToPlay
    }

    cardToPlay = checkForMatch(sourceCard, hand.slice(6))
    if (cardToPlay) {
      return cardToPlay
    }
  }

  if (hasValidCols(hand)) {
    cards = [hand[0], hand[3], hand[6]]
    cardToPlay = checkForMatch(sourceCard, cards)
    if (cardToPlay) {
      return cardToPlay
    }

    cards = [hand[1], hand[4], hand[7]]
    cardToPlay = checkForMatch(sourceCard, cards)
    if (cardToPlay) {
      return cardToPlay
    }

    cards = [hand[2], hand[5], hand[8]]
    cardToPlay = checkForMatch(sourceCard, cards)
    if (cardToPlay) {
      return cardToPlay
    }
  }
  return
}

function hasValidRows(hand) {
  if (hand[2].displayClass !== 'transparent') {
    return true
  }
  return false
}

function hasValidCols(hand) {
  if (hand[6].displayClass !== 'transparent') {
    return true
  }
  return false
}

function checkForMatch(sourceCard, cards) {
  const matchedCards = cards.filter(card => {
    return card.displayClass === 'visible' && card.value === sourceCard.value
  })

  if (matchedCards.length !== 2) {
    return
  }
  const hidden = cards.find(card => {
    return card.displayClass === 'hidden'
  })

  if (hidden) {
    return hidden
  }

  const unmatchedCard = cards.find(card => {
    return card.displayClass === 'visible' && card.value !== sourceCard.value
  })

  return unmatchedCard
}

export { getDoubleMatch }
